export const shorthands = {
    animation: [
        -1,
        [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimeline',
            'animationTimingFunction',
        ],
    ],
    animationRange: [-1, ['animationRangeEnd', 'animationRangeStart']],
    background: [
        -2,
        [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPosition',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize',
        ],
    ],
    backgroundPosition: [-1, ['backgroundPositionX', 'backgroundPositionY']],
    border: [
        -2,
        [
            'borderBottom',
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderLeft',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRight',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTop',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth',
        ],
    ],
    borderBottom: [-1, ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth']],
    borderImage: [
        -1,
        ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
    ],
    borderLeft: [-1, ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth']],
    borderRadius: [
        -1,
        ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
    ],
    borderRight: [-1, ['borderRightColor', 'borderRightStyle', 'borderRightWidth']],
    borderTop: [-1, ['borderTopColor', 'borderTopStyle', 'borderTopWidth']],
    caret: [-1, ['caretColor', 'caretShape']],
    columnRule: [-1, ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth']],
    columns: [-1, ['columnCount', 'columnWidth']],
    containIntrinsicSize: [-1, ['containIntrinsicHeight', 'containIntrinsicWidth']],
    container: [-1, ['containerName', 'containerType']],
    flex: [-1, ['flexBasis', 'flexGrow', 'flexShrink']],
    flexFlow: [-1, ['flexDirection', 'flexWrap']],
    font: [-1, ['fontFamily', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'lineHeight']],
    gap: [-1, ['columnGap', 'rowGap']],
    grid: [
        -1,
        [
            'columnGap',
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridColumnGap',
            'gridRowGap',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows',
            'rowGap',
        ],
    ],
    gridArea: [-1, ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart']],
    gridColumn: [-1, ['gridColumnEnd', 'gridColumnStart']],
    gridRow: [-1, ['gridRowEnd', 'gridRowStart']],
    gridTemplate: [-1, ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows']],
    inset: [-1, ['bottom', 'left', 'right', 'top']],
    insetBlock: [-1, ['insetBlockEnd', 'insetBlockStart']],
    insetInline: [-1, ['insetInlineEnd', 'insetInlineStart']],
    listStyle: [-1, ['listStyleImage', 'listStylePosition', 'listStyleType']],
    margin: [-1, ['marginBottom', 'marginLeft', 'marginRight', 'marginTop']],
    marginBlock: [-1, ['marginBlockEnd', 'marginBlockStart']],
    marginInline: [-1, ['marginInlineEnd', 'marginInlineStart']],
    mask: [
        -1,
        ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPosition', 'maskRepeat', 'maskSize'],
    ],
    maskBorder: [
        -1,
        [
            'maskBorderMode',
            'maskBorderOutset',
            'maskBorderRepeat',
            'maskBorderSlice',
            'maskBorderSource',
            'maskBorderWidth',
        ],
    ],
    offset: [-1, ['offsetAnchor', 'offsetDistance', 'offsetPath', 'offsetPosition', 'offsetRotate']],
    outline: [-1, ['outlineColor', 'outlineStyle', 'outlineWidth']],
    overflow: [-1, ['overflowX', 'overflowY']],
    overscrollBehavior: [-1, ['overscrollBehaviorX', 'overscrollBehaviorY']],
    padding: [-1, ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop']],
    paddingBlock: [-1, ['paddingBlockEnd', 'paddingBlockStart']],
    paddingInline: [-1, ['paddingInlineEnd', 'paddingInlineStart']],
    placeContent: [-1, ['alignContent', 'justifyContent']],
    placeItems: [-1, ['alignItems', 'justifyItems']],
    placeSelf: [-1, ['alignSelf', 'justifySelf']],
    scrollMargin: [-1, ['scrollMarginBottom', 'scrollMarginLeft', 'scrollMarginRight', 'scrollMarginTop']],
    scrollMarginBlock: [-1, ['scrollMarginBlockEnd', 'scrollMarginBlockStart']],
    scrollMarginInline: [-1, ['scrollMarginInlineEnd', 'scrollMarginInlineStart']],
    scrollPadding: [-1, ['scrollPaddingBottom', 'scrollPaddingLeft', 'scrollPaddingRight', 'scrollPaddingTop']],
    scrollPaddingBlock: [-1, ['scrollPaddingBlockEnd', 'scrollPaddingBlockStart']],
    scrollPaddingInline: [-1, ['scrollPaddingInlineEnd', 'scrollPaddingInlineStart']],
    scrollTimeline: [-1, ['scrollTimelineAxis', 'scrollTimelineName']],
    textDecoration: [-1, ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle', 'textDecorationThickness']],
    textEmphasis: [-1, ['textEmphasisColor', 'textEmphasisStyle']],
    transition: [
        -1,
        ['transitionBehavior', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
    ],
    viewTimeline: [-1, ['viewTimelineAxis', 'viewTimelineName']],
};
//# sourceMappingURL=shorthands.js.map